import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { UIBoxVariant, UIBoxDecoration } from '../types';

export interface IBoxProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: UIBoxVariant;
  decoration?: UIBoxDecoration;
  padded?: boolean;
}

export default function Box({
  children,
  className,
  decoration,
  variant = 'white',
  padded,
  ...otherProps
}: IBoxProps): React.ReactElement {
  const bem = bemBlock('box');

  const blockClasses = bem(
    null,
    [{ [variant]: variant }, { padded: padded }, { [`decoration-${decoration}`]: decoration }],
    className
  );

  return (
    <div className={blockClasses} {...otherProps}>
      {children}
    </div>
  );
}
